import moment from 'moment';

export const CHAIN_CATEGORY = [
  'INTERNATIONAL',
  'NATIONAL',
  'REGIONAL',
  'LOCAL',
];

/*****************************
 * @DESC Default Item Image
 ****************************/
export const DEFAULT_ITEM_IMAGE =
  'https://iconslist.s3.amazonaws.com/imagenotavailable.png';

export const NOTAVAILABLEIMAGE =
  'https://amealia.s3.amazonaws.com/60b7435e6dcadb0291ef7868TheLotusSutraHyattRegencyPune-Group%2070774.svg';

export const Hours_24 = Array.from(
  {
    length: 48,
  },
  (_, hour) =>
    moment({
      hour: Math.floor(hour / 2),
      minutes: hour % 2 === 0 ? 0 : 30,
    }).format('HH:mm')
);

export const StatusColorsOrdersBadges = [
  { id: 0, background: '#FFF6DF', color: '#E2A200' },
  { id: 1, background: '#E6FFDF', color: '#25A900' },
  { id: 2, background: '#FFF6DF', color: '#E2A200' },
  { id: 3, background: '#FFF6DF', color: '#E2A200' },
  { id: 4, background: '#E6FFDF', color: '#25A900' },
  { id: 5, background: '#FFF6DF', color: '#E2A200' },
  { id: 6, background: '#E6FFDF', color: '#25A900' },
  { id: 7, background: '#E6FFDF', color: '#25A900' },
  { id: 8, background: '#FFDFDF', color: '#EE3A23' },
];

export const PRODUCTCLASSIFICATION = [
  {
    _id: '61b6d3d8cfe1015e07404c18',
    category_name: 'Food Classification',
    title: 'Food',
  },
  {
    _id: '61b6d400cfe1015e07404c19',
    category_name: 'Beverage Classification',
    title: 'Beverage',
  },
  {
    _id: '61b6d421cfe1015e07404c1a',
    category_name: 'Alcoholic Beverage Classification',
    title: 'Alcoholic Beverage',
  },
  {
    _id: '61b6d451cfe1015e07404c1b',
    category_name: 'Packed Food Classification',
    title: 'Packed Food',
  },
  {
    _id: '61b6d47bcfe1015e07404c1c',
    category_name: 'Packed Beverage Classification',
    title: 'Packed Beverage',
  },
  {
    _id: '669f8bf6aef4fc159792eee3',
    category_name: 'Accessories Classification',
    title: 'Accessories/Gifts & Apparel',
  },
  {
    _id: '669f8b68aef4fc159792eee1',
    category_name: 'Non Food',
    title: 'Non-Food',
  },
  {
    _id: '669f8bb0aef4fc159792eee2',
    category_name: 'Services Classification',
    title: 'Services',
  },
  {
    _id: '61b6d4afcfe1015e07404c1g',
    category_name: 'Accessories',
    title: 'Accessories/Gifts & Apparel',
  },
];

export const MERCHANT_TAGS = [
  { id: 0, title: 'PREMIUM', color: '#6D5AE7' },
  { id: 1, title: 'RECOMMENDED', color: '#FD9025' },
  { id: 2, title: 'BEST SELLER', color: '#22CAFD' },
  { id: 3, title: 'MOST VISITED', color: '#1EC730' },
];

export const MERCHANT_PROMOTION_STATUS = [
  { id: 0, title: 'Request Created', color: '#FFF183' },
  { id: 1, title: 'Approved', color: '#06A200' },
  { id: 2, title: 'Rejected', color: '#EE3A23' },
  { id: 3, title: 'Validated', color: '#06A200' },
  { id: 4, title: 'Pending', color: '#FCB614' },
  { id: 5, title: 'Cancelled', color: '#EE3A23' },
];

export const MERCHANT_PROMOTION_FILTER = [
  { id: 0, status: 6, title: 'All', color: '#6D5AE7' },
  { id: 1, status: 4, title: 'Pending', color: '#6D5AE7' },
  { id: 2, status: 3, title: 'Validated', color: '#6D5AE7' },
  { id: 3, status: 1, title: 'Approved', color: '#6D5AE7' },
  { id: 4, status: 2, title: 'Rejected', color: '#6D5AE7' },
  { id: 5, status: 5, title: 'Cancelled', color: '#6D5AE7' },
];

export const EVENT_RSVP_ICON = 'https://iconslist.s3.amazonaws.com/RSVP.svg';
export const EVENT_TICKET_ICON =
  'https://iconslist.s3.amazonaws.com/event_tickets.svg';
export const WALKIN_ICON = 'https://iconslist.s3.amazonaws.com/walkin.svg';
export const WAITLIST_ICON = 'https://iconslist.s3.amazonaws.com/waitlist.svg';
export const RESERVATION_ICON =
  'https://iconslist.s3.amazonaws.com/Reservation.svg';
export const PAY_ICON = 'https://iconslist.s3.amazonaws.com/pay.svg';

export const OFFER_ACTIVE_SERVICE = [
  { name: 'All', show: false },
  { name: 'Takeaway', show: false },
  { name: 'Curbside', show: false },
  { name: 'Skip the line', show: false },
  { name: 'Dine-In', show: false },
  { name: 'Buffet', show: false },
  { name: 'Catering', show: false },
  { name: 'Drive Thru', show: false },
  { name: 'Delivery', show: false },
];

export const userReasonForFlag = [
  {
    id: 0,
    title: 'Junk User (No Transactions for <90 days)',
    value: 'Junk User (No Transactions for <90 days)',
  },
  {
    id: 1,
    title: 'Malicious activities/Behavior',
    value: 'Malicious activities/Behavior',
  },
  {
    id: 2,
    title: 'Flagged for Archival',
    value: 'Flagged for Archival',
  },
  {
    id: 3,
    title: 'Other',
    value: 'Other',
  },
];

export const userReasonForBlock = [
  {
    id: 0,
    title: 'Multiple cancellations',
    value: 'Multiple cancellations',
  },
  {
    id: 1,
    title: 'Placing unnecessary orders/requests',
    value: 'Placing unnecessary orders/requests',
  },
  {
    id: 2,
    title: 'Misbehaving with merchant/customer care/deliver person or partner',
    value: 'Misbehaving with merchant/customer care/deliver person or partner',
  },
  {
    id: 3,
    title: 'Other',
    value: 'Other',
  },
];
export const SETTLEMENT_TYPE = [
  { id: 0, title: 'Order', value: '0' },
  { id: 1, title: 'Tip', value: '1' },
  { id: 2, title: 'Events', value: '2' },
  { id: 3, title: 'Scan & Pay', value: '3' },
  { id: 4, title: 'Experience', value: '4' },
];

export const expStatusBadge = {
  COMPLETED: { badge: 'badge-success', name: 'Completed' },
  CANCELLED: { badge: 'badge-danger', name: 'Cancelled' },
  REJECTED: { badge: 'badge-danger', name: 'Rejected' },
  PENDING: { badge: 'badge-warning', name: 'Pending' },
  NOTSEATED: { badge: 'badge-warning', name: 'Not Seated' },
  SEATED: { badge: 'badge-warning', name: 'Seated' },
};

export const expPaymentStatusBadge = [
  { badge: 'badge-warning', name: 'Pending' },
  { badge: 'badge-success', name: 'Completed' },
  { badge: 'badge-danger', name: 'Cancelled' },
  { badge: 'badge-danger', name: 'Failure' },
];
